import {Observable} from "rxjs";
import {Comment} from "./comment";
import {Floor} from "./floor";
import {Unit} from "./unit";
import {Room} from "./room";
import {Area} from "./area";
import {HistoryItem} from "./historyItem";

export enum LinkedElementType {
  PROJECT_ELEMENT = "PROJECT",
  FLOOR_ELEMENT = "FLOOR",
  UNIT_ELEMENT = "UNIT",
  ROOM_ELEMENT = "ROOM",
  AREA_ELEMENT = "AREA",
}

export type CommentableElementType = LinkedElementType.FLOOR_ELEMENT | LinkedElementType.UNIT_ELEMENT | LinkedElementType.ROOM_ELEMENT | LinkedElementType.AREA_ELEMENT;
export type CommentService = {
  get: (id: number) => Observable<Comment[]>;
  create: (entityId: number, fd: FormData) => Observable<Comment>;
  edit: (fd: FormData) => Observable<Comment>;
  delete: (commentId: number) => Observable<Object>;
};

export type ElementServiceType = {
  getById: (elementPublicId: string) => Observable<Floor | Unit | Room | Area>;
  getHistory: (id: number) => Observable<HistoryItem[]>;
};
